export enum Modal {
  MATCH_CREATION_SOURCE_DECIDER,
  CRICINFO,
  MATCH_CREATOR,
  SQUAD_CREATOR_1,
  SQUAD_CREATOR_2,
  SUMMARY,
}
